// extracted by mini-css-extract-plugin
export default {"brandPromo":"lH-z","carousel":"mH-z"};